import { jsx as _jsx } from "react/jsx-runtime";
const statusColors = {
    excellent: {
        bg: 'var(--color-accent-primary)',
        color: 'var(--color-bg-base)',
        border: 'var(--color-accent-primary)',
    },
    good: {
        bg: 'transparent',
        color: 'var(--color-accent-primary)',
        border: 'var(--color-accent-primary)',
    },
    caution: {
        bg: 'var(--color-warning)',
        color: 'var(--color-bg-base)',
        border: 'var(--color-warning)',
    },
    risk: {
        bg: 'var(--color-danger)',
        color: 'var(--color-bg-base)',
        border: 'var(--color-danger)',
    },
};
export function Badge({ status, children }) {
    const colors = statusColors[status];
    return (_jsx("span", { style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '2px 10px',
            borderRadius: 'var(--radius-full)',
            fontSize: 'var(--text-xs)',
            fontWeight: 500,
            fontFamily: 'var(--font-body)',
            background: colors.bg,
            color: colors.color,
            border: `1px solid ${colors.border}`,
            animation: 'badgeFadeIn 200ms var(--easing-default)',
        }, children: children }));
}
//# sourceMappingURL=Badge.js.map